module.exports = __webpack_public_path__ + "static/media/arrow-point-to-right.a0e061b5.svg";